import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash, key } = useLocation();
    useEffect(() => {
        const frame = window.requestAnimationFrame(() => {
            const target = hash && document.getElementById(hash.slice(1));
            if (target) {
                target.scrollIntoView();
            } else {
                window.scrollTo(0, 0);
            }
        });
        return () => window.cancelAnimationFrame(frame);
    }, [pathname, hash, key]);
    return null;
}
